import React from 'react';
import {
  makeStyles,
  TableCell,
  TableHead as TableHeadMaterial,
  TableRow
} from '@material-ui/core';

const useStyles = makeStyles({
  th: {
    lineHeight: '1rem',
    padding: '0.5rem 1rem',
    fontWeight: 500,
    color: '#2f2f2f80'
  }
});

interface TableHeadProps {
  cells: Array<any>;
  className?: string;
}

const TableHead = ({ cells, className }: TableHeadProps) => {
  const classes = useStyles();
  return (
    <TableHeadMaterial>
      <TableRow className={className}>
        {cells.map((cellName: any, index: number) => {
          return (
            <TableCell className={classes.th} key={index}>
              {cellName}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHeadMaterial>
  );
};

export default TableHead;
